// @flow

import * as React from "react";
import { ToastContainer } from "react-toastify";
import config from "@config";
import { Helmet } from "react-helmet";
import { localize } from "redux-i18n";
import { Link } from "react-router-dom";
import { route } from "@routes/helper";
import "./common-layout.style.scss";

type PropsFromState = $Exact<{
  title: string,
  children: React.Node,
}>;

type Props = { ...PropsFromState, ...PropsFromLocalize };

export class CommonLayout extends React.Component<Props> {
  render() {
    return (
      <div className="page-common mx-auto py-0 w-100">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.props.title}</title>
        </Helmet>
        <div className="w-100 d-flex flex-row px-5 py-4 justify-content-between">
          <Link
            aria-label={this.props.t("GO_HOME")}
            to={route("HOME_PATH")}
            className="header-logo"
          />
        </div>
        <div className="w-100 m-0">
          <div className="content col-12 p-0">{this.props.children}</div>
        </div>
        <div className="w-100 d-flex flex-row px-5 py-5 justify-content-center">
          <div>© {this.props.t("FIRSTCARE_LTD_2019_ALL_RIGHTS_RESERVED")}</div>
        </div>
        <ToastContainer
          position="bottom-left"
          type="default"
          autoClose={config.toasterShowTime}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />
      </div>
    );
  }
}

export default localize()(CommonLayout);
